<template>
	<div class="sv-preview">
		<img :src="image" :style="style" class="my-handle"/>
		<i v-if="isDeleteButtonShow" class="far fa-trash-alt remove-button" @click.prevent="onDeleteClick"></i>
	</div>
</template>

<script>

export default {
	name: 'Preview',
	props: {
		image: {
			type: String,
			default: '',
		},
		maxH: {
			type: Number,
			default: 90,
		},
		isDeleteButtonShow: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		style: function() {
			return {
				'max-height': this.maxH + 'px',
			};
		},
	},
	methods: {
		onDeleteClick: function() {
			this.$utils.log('onDeleteClick');
			this.$emit('delete-click');
		},
	},
}
</script>

<style lang="scss">

</style>
